import React, { useState } from "react";
import { FaBars, FaTimes } from "react-icons/fa";
import logo from "../assets/img/Ibullz.png";
import { NavLink } from "react-router-dom";
import MenuHome from "../assets/img/home.svg";
import MenuAffiliate from "../assets/img/referral-bonus.svg";
import ReferralBonus from "../assets/img/referral-bonus.svg";
import LevelBonus from "../assets/img/level-bonus.svg";
import GlobalBonus from "../assets/img/global-bonus.svg";
import MyReferralList from "../assets/img/my-referral-list.svg";
import MyDownlineList from "../assets/img/my-downline-list.svg";
import AllBonusLog from "../assets/img/bonus-log.svg";
import MenuBg from "../assets/img/menu.jpg";
import AutoTrade from "../assets/img/AutoTrade.svg";
import LevelBusinessChart from "../assets/img/business-chart.svg";
import CappingChart from "../assets/img/capping-chart.svg";
import Logout from "../assets/img/logout.svg";
import { useDisconnect } from "wagmi";
import { useAppKitAccount } from "@reown/appkit/react";

// const ADMIN_ADDRESS = "0xAC10Da3fbD057E6Fd3686abd9012Ce1d82a62891";
const ADMIN_ADDRESSES = [
  "0x5FD893dF1A7c03f1F673Aa164632A7282Ddd8989",
  "0xd321fb8144534A90f3C002781Ca6f9660e376030"  
];

const Header = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
const { address, isConnected } = useAppKitAccount();

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const closeSidebar = () => {
    setIsSidebarOpen(false);
  };
const { disconnect } = useDisconnect();
// const isAdmin =
//   isConnected &&
//   address &&
//   address.toLowerCase() === ADMIN_ADDRESS.toLowerCase();

const isAdmin =
  isConnected &&
  address &&
  ADMIN_ADDRESSES.some(
    (admin) => admin.toLowerCase() === address.toLowerCase()
  );


  return (
    <>
      {/* Mobile Header */}
      <div className="header-mobile">
        <img src={logo} alt="logo" className="logo-mobile" />
        <button className="sidebar-btn" onClick={toggleSidebar}>
          {isSidebarOpen ? (
            <FaTimes className="fa-solid" />
          ) : (
            <FaBars className="fa-solid" />
          )}
        </button>
      </div>

      {/* Overlay */}
      <div
        className={`overlay ${isSidebarOpen ? "active" : ""}`}
        onClick={closeSidebar}
      ></div>

      {/* Sidebar */}
      <div className={`sideBar ${isSidebarOpen ? "open" : ""}`}>

<img src={MenuBg} alt="" className="MenuBg" />

      <div className="Menu-relative">
          <a href="/" className="logo-name">
          <img src={logo} alt="logo" />
        </a>

        <div className="connect-wallet-side">
          <w3m-button />
        </div>

        <div className="MenuSideDiv">
          <ul className="menu-side-list">
            <li>
              <NavLink to="/" onClick={closeSidebar}>
                <img src={MenuHome} alt="" /> <span>Home</span>
              </NavLink>
            </li>

            <li>
              <NavLink to="/deposit-trading-funds" onClick={closeSidebar}>
                <img src={AutoTrade} alt="" /> <span>Deposit Trading Funds</span>
              </NavLink>
            </li>

            <li>
              <NavLink to="/nft-market-place" onClick={closeSidebar}>
                <img src={MenuAffiliate} alt="" /> <span>NFT Market Place</span>
              </NavLink>
            </li>

            <li>
              <NavLink to="/affiliate-details" onClick={closeSidebar}>
                <img src={MenuAffiliate} alt="" /> <span>Affiliate Details</span>
              </NavLink>
            </li>

             {/* <li>
              <NavLink to="/reserve-log" onClick={closeSidebar}>
                <img src={MenuAffiliate} alt="" /> <span>Security Vault Details</span>
              </NavLink>
            </li> */}
{/* 
             <li>
              <NavLink to="/auto-trade" onClick={closeSidebar}>
                <img src={AutoTrade} alt="" /> <span>Auto Trade</span>
              </NavLink>
            </li> */}

            <li>
              <NavLink to="/referral-bonus" onClick={closeSidebar}>
                <img src={ReferralBonus} alt="" /> <span>Referral Bonus</span>
              </NavLink>
            </li>

            <li>
              <NavLink to="/level-bonus" onClick={closeSidebar}>
                <img src={LevelBonus} alt="" /> <span>Level Bonus</span>
              </NavLink>
            </li>

            <li>
              <NavLink to="/royalty-bonus" onClick={closeSidebar}>
                <img src={GlobalBonus} alt="" /> <span>Royalty Bonus</span>
              </NavLink>
            </li>

            <li>
              <NavLink to="/my-referral-list" onClick={closeSidebar}>
                <img src={MyReferralList} alt="" /> <span>My Referral List</span>
              </NavLink>
            </li>

            <li>
              <NavLink to="/my-all-affiliate" onClick={closeSidebar}>
                <img src={MyDownlineList} alt="" /> <span>My Downline List</span>
              </NavLink>
            </li>

            <li>
              <NavLink to="/all-bonus-log" onClick={closeSidebar}>
                <img src={AllBonusLog} alt="" /> <span>All Bonus Log</span>
              </NavLink>
            </li>

            {/* {isAdmin && (
  <li>
    <NavLink to="/admin-company-details" onClick={closeSidebar}>
      <img src={MyDownlineList} alt="" /> <span>Admin Panel</span>
    </NavLink>
  </li>
)} */}

            

            <li onClick={() => { disconnect(); closeSidebar(); }}>
              <span className="logout-span">
                <img src={Logout} alt="" /> <span>Disconnect</span>
              </span>
            </li>
            {/* <li>
              <NavLink to="/capping-chart" onClick={closeSidebar}>
                <img src={CappingChart} alt="" /> <span>Capping Chart</span>
              </NavLink>
            </li> */}
          </ul>
        </div>
      </div>
      </div>
    </>
  );
};

export default Header;
